import React from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { Badge } from "@/components/ui/badge";
import { Search } from "lucide-react";
import { mediaUrl } from "@/lib/api";

export const AdCard = ({ ad, index = 0, onInquire }) => {
  const { t, formatPrice } = useApp();
  const navigate = useNavigate();

  return (
    <article
      data-testid={`ad-card-${ad.id}`}
      className="pv-in group relative bg-[color:var(--c-bg)] border border-[color:var(--c-border)] hover:border-[color:var(--c-ink)] transition-colors"
      style={{ animationDelay: `${Math.min(index * 45, 500)}ms` }}
    >
      <div
        className="relative overflow-hidden cursor-zoom-in aspect-[4/5] bg-[color:var(--c-surface)]"
        onClick={() => navigate(`/ad/${ad.id}`)}
        data-testid={`ad-image-${ad.id}`}
      >
        <img
          src={mediaUrl(ad.image)}
          alt={ad.title}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-125"
        />
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors" />
        <div className="absolute top-0 left-0 flex flex-col gap-1 p-3">
          {ad.era && <Badge className="rounded-none bg-[color:var(--c-dark)] text-[color:var(--c-on-dark)] text-[0.6rem] tracking-widest uppercase px-2">{ad.era}</Badge>}
        </div>
        <div className="absolute bottom-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity">
          <span className="flex items-center gap-1 bg-[color:var(--c-glass)] text-[color:var(--c-ink)] text-[0.6rem] tracking-widest uppercase px-2 py-1 font-semibold">
            <Search size={11} /> {t("hover_zoom")}
          </span>
        </div>
      </div>

      <div className="p-4">
        <div className="flex items-start justify-between gap-2">
          <div className="min-w-0">
            <p className="pv-label">{ad.category}</p>
            <h3
              className="font-serif text-xl leading-tight mt-1 truncate cursor-pointer hover:text-[color:var(--c-accent)] transition-colors"
              onClick={() => navigate(`/ad/${ad.id}`)}
            >
              {ad.title}
            </h3>
          </div>
          <span className="font-serif text-xl whitespace-nowrap">{formatPrice(ad.price_usd)}</span>
        </div>
        <div className="flex items-center gap-2 mt-3">
          {ad.ad_language && <span className="text-xs text-[color:var(--c-ink2)]">{ad.ad_language}</span>}
          {ad.brand && <span className="text-xs text-[color:var(--c-ink2)]">· {ad.brand}</span>}
        </div>
        <div className="flex gap-2 mt-4">
          <button
            data-testid={`view-details-${ad.id}`}
            onClick={() => navigate(`/ad/${ad.id}`)}
            className="flex-1 border border-[color:var(--c-ink)] text-[color:var(--c-ink)] hover:bg-[color:var(--c-dark)] hover:text-[color:var(--c-on-dark)] transition-colors px-3 py-2 text-xs tracking-[0.12em] uppercase font-semibold"
          >
            {t("view_details")}
          </button>
          <button
            data-testid={`inquire-card-${ad.id}`}
            onClick={() => onInquire(ad)}
            className="flex-1 bg-[color:var(--c-dark)] text-[color:var(--c-on-dark)] hover:bg-[color:var(--c-accent)] transition-colors px-3 py-2 text-xs tracking-[0.12em] uppercase font-semibold"
          >
            {t("inquire")}
          </button>
        </div>
      </div>
    </article>
  );
};
